module.exports = __webpack_public_path__ + "img/bombEffect2.adbfa266.svg";